import * as React from 'react';
import { connect } from 'react-redux';
import DataTable from '../DataTable';
import moment from 'moment';
import SelectList from '../RBSelectList/RBSelectList';
import { IGenericError } from './common/defaults';
import { toast } from 'react-toastify';
import {
  getAllErrors, getTestErrors
} from './redux-objects/actions';
import { Form, Button, Modal } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import { GetURIByParts } from '../../services/Utils/StringUtils';
import { UserInfo } from '../Login/common/defaults';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

enum ServiceEndPoints {
  GetAllErrors = 'GetAllErrors',
  GetTestErrors = 'ElasticLowLevelTest'
}
export interface IHealthDashboardActionProps {
  getAllErrors?: (url: string) => void;
  getTestErrors?: (url: string) => void;
}

interface IHealthDashboardStateProps {
  webServiceURL: string;
  elasticSearchURL: string;
  currentUser: UserInfo;
  allErrors: [],
  testErrors: any
}

interface IHealthDashboardsProps
  extends IHealthDashboardActionProps,
  IHealthDashboardStateProps { }

const initialState = {
  tableColumns: [],
  logTypes: [],
  selectedLogTypeValue: '-1',
  tableKey: 1,
  showModal: false,
  selectedLog: null,
};

type HealthDashboardState = Readonly<typeof initialState>;

class HealthDashboard extends React.Component<
  IHealthDashboardsProps,
  HealthDashboardState
> {
  public constructor(props: IHealthDashboardsProps) {
    super(props);
    this.state = initialState;
  }

  private esController: string = 'ElasticSearch';


  populateTable = () => {
    this.props.getAllErrors(
      GetURIByParts(
        this.props.webServiceURL,
        this.esController,
        ServiceEndPoints.GetAllErrors
      )
    );
    this.props.getTestErrors(
      GetURIByParts(
        this.props.webServiceURL,
        this.esController,
        ServiceEndPoints.GetTestErrors
      )
    );
  }

  componentDidMount() {
    this.populateTable();
  }

  handleView(event: React.MouseEvent<HTMLElement>, fullLogData: any) {
    this.setState({
      selectedLog: fullLogData,
      showModal: true,
    });
  }
  closeModal = (e?) => {
    this.setState({
      showModal: false,
    });
  };

  public render() {
    const options = {
      dom: 'Bfrtip',
    };

    const columns = [
      {
        title: '',
        data: 'id',
      },
      {
        title: 'Log',
        data: 'index',
      },
      {
        title: 'Message',
        data: 'message',
      },
      {
        title: 'Description',
        data: 'description',
      }
    ];

    const columnDefs = [
      {
        targets: 0,
        width: '120px',
        orderable: false,
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleView(cellData, rowData)}
              >
                {' '}
                View Full Log
              </Button>
            </div>,
            td
          ),
      },
    ];


    return (
      <div className='app'>
      <h2>Health Dashboard</h2><Button variant='secondary' onClick={this.populateTable}>
                  Refresh
                </Button><hr></hr>
      <h3>Recent Errors:</h3>
        {this.props.allErrors && (
          <div>
            {this.props.allErrors.length > 0 && (
              <div>
                <DataTable
                  // key={this.state.selectedHealthDashboard}
                  id='tblLookupViewer'
                  data={this.props.allErrors}
                  columns={columns}
                  columnDefs={columnDefs}
                  actionsColumn='first'
                  order={[[1, 'asc']]}
                  {...options}
                />
              </div>
            )}
            {/* {this.props.testErrors && (
              <div>
                <pre>{JSON.stringify(this.props.testErrors, null, 4)}</pre>
              </div>
            )} */}

        <Modal show={this.state.showModal} onHide={this.closeModal}>
              <Modal.Header closeButton>
                <Modal.Title> Full Log Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <pre>{JSON.stringify(this.state.selectedLog, null, 4)}</pre>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='secondary' onClick={this.closeModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    webServiceURL: state.Application.backendURL,
    elasticSearchURL: state.Application.elasticSearchURL,
    currentUser: state.Application.currentUser,
    allErrors: state.HealthDashboard.allErrors,
    testErrors: state.HealthDashboard.testErrors
  };
};

const mapDispatchToProps = {
  getAllErrors,
  getTestErrors
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthDashboard);
